import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../data/site";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="whatsapp-float-button"
      href={waLink("Hello Vayu Celebrations! I'd like to plan an event.")}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 15 }}
      whileHover={{ scale: 1.08 }}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-gold text-night shadow-[0_16px_40px_-12px_rgba(176,141,66,0.8)]"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-gold opacity-25 [animation-duration:2.5s]" />
    </motion.a>
  );
}
